import {
  InlineNotification as CXInlineNotification,
  IInlineNotification as CXIInlineNotification
} from '@sanlamcx/react-ui-next-inline-notification';

type InlineNotification = typeof CXInlineNotification;
export type IInlineNotification = CXIInlineNotification;
export const InlineNotification: InlineNotification = CXInlineNotification;
